__turbopack_context__.v({
  "card": "_491P8q_card",
  "subtitle": "_491P8q_subtitle",
});
